<template>
  <div class="container">
    <el-cascader :options="options" ref="cascader" :props="props" @change="menuchange" v-model="checkedArray" collapse-tags @remove-tag="removeTag"
      clearable></el-cascader>
  </div>
</template>

<script>
import { getUserInfos,getListMyDepts,getlistEhrDepts } from "@/api/health/Patients";
export function transListToTreeData(list, RootValue) {
  let arr = [];
  list.forEach((item, index) => {
    //如果数据对象的pid为 '' 说明数据为根节点
    if (item.parentId == RootValue) {
      let children = transListToTreeData(list, item.deptId); //寻找id等于该对象pid的数据，为它的子节点,返回一个数组
      if (children.length) {
        item.children = children; //往对象添加一个children属性，属性值为一个数组
      }
      arr.push({ label: item.name, children: item.children });
    }
  });
  return arr;
}

export default {
  data() {
    return {
      props: {
        children: "children",
        label: "label", 
        multiple: true
      },
      options: [],
      checkedArray: null,
      values: []
    }
  },
  created() {
    this.values = [];
    this.getManageHospital();
  },
  methods: {
    // 获取机构名称
    getManageHospital() {
      const params = {
      };
      getlistEhrDepts(params).then((res) => {
        if ((res.msg = "success")) {
          this.managerHospitalList = res.data.hospitals;
          this.$nextTick(() => {
            if (this.managerHospitalList.length == 1) {
              this.options = [{ label: this.managerHospitalList[0].name, children: null }]
            } else {
              this.options = transListToTreeData(this.managerHospitalList, res.data.hospitalId)
            }
          })
          console.log("联动选择器", this.options)
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    menuchange() {
      this.values = this.$refs['cascader'].getCheckedNodes().map((item) => {
        return item.label;
      }); //选中节点数据
      console.log(this.values)
      this.$emit("input", this.values);
    },
    removeTag() {
      this.$refs['cascader'].$refs.panel.clearCheckedNodes();
    }

  }
}
</script>